module.exports = __webpack_public_path__ + "img/createAdmin5.64b0d8fe.svg";